import Swiper from 'swiper';
import { Navigation, Autoplay, Parallax, Pagination } from 'swiper/modules';
import { Fancybox } from '@fancyapps/ui/src/Fancybox/Fancybox.js';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/autoplay';
import 'swiper/scss/effect-fade';
Fancybox.bind('a[preview]', {
    groupAll: true,
    on: {
        ready: () => {
            setTimeout(() => {
                document
                    .querySelector('.fancybox__track')
                    .setAttribute('style', 'transform: translate3d(0px, 0px, 0px) scale(1);');
            }, 0);
        },
    },
});
if (customElements.get('product-media') === undefined) {
    class RecommendationsSlider extends HTMLElement {
        constructor() {
            super();
            this.speed = 700;
            this.pushImages = this.pushImages.bind(this);
        }
        connectedCallback() {
            this.initLarges();
            this.initThumbs();
        }
        initLarges() {
            const container = this.querySelector('.swiper.previews');
            const prev = this.querySelector('.nav-button-prev');
            const next = this.querySelector('.nav-button-next');
            this.previews = new Swiper(container, {
                modules: [Navigation, Parallax, Autoplay, Pagination],
                mousewheel: true,
                speed: this.speed,
                longSwipesRatio: 0.01,
                followFinger: false,
                grabCursor: true,
                watchSlidesProgress: true,
                parallax: true,
                lazy: {
                    loadPrevNext: true,
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                },
                on: {
                    slideChange: () => {
                        this.thumbs.slideTo(this.previews.activeIndex);
                    }
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
            });
        }
        initThumbs() {
            const container = this.querySelector('.swiper.thumbs');
            this.thumbs = new Swiper(container, {
                modules: [Navigation],
                on: {
                    tap: (swiper) => {
                        this.previews.slideTo(swiper.clickedIndex);
                    }
                },
                // Vertical
                direction: 'vertical',
                slidesPerView: 4,
                spaceBetween: 10,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: '.swiper-button-prev',
                    prevEl: '.swiper-button-next',
                },
            });
        }
        pushImages(images) {
            images = images.map((image) => image?.src || image).map((image) => 'https:' + image);
            console.log(images);
            const previewSlides = images.map((image) => {
                const str = `
          <div class="swiper-slide">
            <div class="swiper-slide-inner" data-swiper-parallax="50%">
              <a preview href="${image}">
                <img src="${image}&width=850"
                data-src="${image}&width=1200"
                loading="lazy">
              </a>
            </div>
          </div>
        `;
                return new DOMParser().parseFromString(str, 'text/html').body.firstChild;
            });
            const thumbSlides = images.map((image) => {
                const str = `
          <div class="swiper-slide">
            <img src="${image}&width=200"
            data-src="${image}&width=200"
            loading="lazy">
          </div>
        `;
                return new DOMParser().parseFromString(str, 'text/html').body.firstChild;
            });
            const videoSlidesPreviews = Array.from(this.previews.$wrapperEl[0].querySelectorAll('.swiper-slide.-video'));
            const videoSlidesThumbs = Array.from(this.thumbs.$wrapperEl[0].querySelectorAll('.swiper-slide.-video'));
            this.previews.$wrapperEl[0].innerHTML = '';
            this.thumbs.$wrapperEl[0].innerHTML = '';
            this.previews.$wrapperEl[0].prepend(...previewSlides, ...videoSlidesPreviews);
            this.thumbs.$wrapperEl[0].prepend(...thumbSlides, ...videoSlidesThumbs);
            this.previews.update();
            this.thumbs.update();
        }
    }
    customElements.define('product-media', RecommendationsSlider);
}
